import { Canvas } from '@thive/canvas';
import { create } from 'zustand';

type CanvasEventState = {
  instance: Canvas | undefined;
  mousePosition: { x: number; y: number };
  canvasNativeZoomLevel: number;
  zoomDisplayValue: number;
  /**
   * @description scale by which to the canvas its native zoom level is handled by our own app. // TODO: clarify descrption with examples
   */
  nativeZoomToUserZoomFactor: number;
};

type CanvasEventAction = {
  initialize(instance: Canvas): void;
  dispose(): void;
  setMousePosition(x: number, y: number): void;
  setZoomValues(values: { canvasNativeZoomLevel: number; zoomDisplayValue: number }): void;
  setNativeZoomToUserZoomFactor(factor: number): void;
};

const INITIAL_STATE: CanvasEventState = {
  instance: undefined,
  mousePosition: { x: 0, y: 0 },
  canvasNativeZoomLevel: 100,
  zoomDisplayValue: 100,
  nativeZoomToUserZoomFactor: 1,
};

interface IStore extends CanvasEventState, CanvasEventAction {}

// NOTE: no devtools for this store. Redux devtools not suited for canvas instance

export const useStore = create<IStore>()((set, get) => ({
  ...INITIAL_STATE,
  initialize: (instance: Canvas) => {
    set({ instance });
  },
  dispose: () => {
    get().instance?.dispose();
    set({ instance: undefined });
  },
  setMousePosition(x: number, y: number) {
    set({ mousePosition: { x, y } });
  },
  setZoomValues(values: { canvasNativeZoomLevel: number; zoomDisplayValue: number }) {
    set({
      canvasNativeZoomLevel: values.canvasNativeZoomLevel,
      zoomDisplayValue: values.zoomDisplayValue,
    });
  },
  setNativeZoomToUserZoomFactor(value: number) {
    set({
      nativeZoomToUserZoomFactor: value,
    });
  },
}));
